import vannav from "./vannav.vue";
import boxtop from "./boxtop.vue";
import textbox from "./textbox.vue";
import empty from "./global-empty.vue";
import vanhome from "./global-empty.vue";

export default {
  vannav,
  boxtop,
  textbox,
  vanhome,
  empty,
};
